module.exports = __webpack_public_path__ + "media/images/covid/banner/ko-28267e426b17633db87bbde7b6bf428e.jpg";